import React, { useRef, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle, faMinusCircle } from "@fortawesome/free-solid-svg-icons";
import { Document, Page } from "react-pdf";
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import Wrapper from "./esignPdfPage.styles";
import EsignPdfNavigation from "./esignPdfNavigation";
import DocumentLink from "../components/documentLink";
import { Loader } from "@components/loader";
import { configurePdfJsWorker } from "@src/utils/helpers/pdfWorkerHelper";

export const EsignPdfPage = ({ accountExternalId, activeDocumentType, numPages, handleDocumentNavigation, onDocumentLoadSuccess }) => {
  const docWidthRef = useRef(null);
  const [width, setWidth] = useState(null);
  const [initialWidth, setInitialWidth] = useState(null);
  const { pdfUrlData } = useSelector((state) => state.esign);
  const activeDocumentTypeName = activeDocumentType.name;
  const activeDocumentBlobUrl = activeDocumentTypeName === "Contract" ? pdfUrlData.contract : pdfUrlData.repayment;
  
  configurePdfJsWorker();

  useEffect(() => {
    if (docWidthRef.current.offsetWidth <= 1200) {
      setWidth(docWidthRef.current.offsetWidth);
      setInitialWidth(docWidthRef.current.offsetWidth)
    } else {
      setWidth(1200);
      setInitialWidth(1200)
    }
  }, [docWidthRef, setWidth, accountExternalId]);

  const zoomIn = () => {
    setWidth(width + 150);
  }

  const zoomOut = () => {
    if (width > initialWidth) {
      setWidth(width - 150);
    }
  }

  return (
    <Wrapper>
      <h1 className="esign-title">eSign your contract</h1>
      <EsignPdfNavigation activeDocumentType={activeDocumentType} handleDocumentNavigation={handleDocumentNavigation}/>
      <div className="pdf-options">
        <div className="download-container"><DocumentLink activeDocumentType={activeDocumentType} className="esign-download" buttonText={`Optional: Download ${activeDocumentType.name}`} onClick={()=>{}}/></div>
        <div className="zoom-buttons">
          <button className="zoom-out-button" type="button" onClick={zoomOut}><FontAwesomeIcon size="2x" className="zoom-out-icon" icon={faMinusCircle} /></button>
          <p className="zoom-text">ZOOM</p>
          <button className="zoom-in-button" type="button" onClick={zoomIn}><FontAwesomeIcon size="2x" className="zoom-in-icon" icon={faPlusCircle} /></button>
        </div>
      </div>
      <div className="pdf-group" ref={docWidthRef}>
        <Document
          renderMode="canvas"
          file={activeDocumentBlobUrl}
          onLoadSuccess={onDocumentLoadSuccess}
          loading={<Loader/>}
        >
          {Array.from(new Array(numPages), (el, index) => (
            <div key={`page_${index + 1}`} className="pdf-wrapper" style={{width: width}}> 
              <Page
                width={width}
                pageNumber={index + 1}
                className="document-page"
              />
            </div>
          ))}
        </Document>
      </div>
    </Wrapper>
  );
};

export default EsignPdfPage;
